<!-- ======= Hero Section ======= -->
<section class="login-page-section-top">
    <div class="container">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">
                    <h3 class="txt-advert animated fadeInUp">Tennis Premier League </h3>
                    <p class="txt-advert-sub animated">Your all-access pass to experience the action on tour</p>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of bannerImageList " class="swiper-slide zoom-effect-container banner-image-div">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="banner" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <!-- <div class="headings-section-banner">
        <h4 class="tracking-in-contract">CREATIVE</h4>
        <div class="main-heading tracking-in-contract new">
            WEB DESIGN.
        </div>
    </div> -->
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-toast key="toastmsg" position="top-right"></p-toast>
<section *ngIf="!showForgotPasswordForm" class="login-page-section  sign-up-section-main-page">
    <div class="section-title text-center">
        <p> REGISTER NOW !
        </p>
    </div>
    <div class="col-md-12 to-button-toogle">
        <ul class="top-navigation-button">
            <li [routerLinkActive]="'active'">
                <a routerLink="/sign-in">
                    <button>
                        LOGIN
                    </button>
                </a>
            </li>
            <li [routerLinkActive]="'active'">
                <a routerLink="/sign-up">
                    <button>
                        REGISTER
                    </button>
                </a>
            </li>
        </ul>
        <p-tabView [(activeIndex)]="activeIndex">

            <p-tabPanel header=" REGISTER" class="registration-forms">
                <div class="container">
                    <div class="row">

                        <div class="col-md-12">
                            <div *ngIf="!showOtpForm" class="col-md-12 login-page ragister-page-div">
                                <form class="login-form" [formGroup]="signUpForm" *ngIf="this.signUpForm"
                                    (ngSubmit)="onSignupSubmit()">
                                    <div class="row">
                                        <div class="Firstname col-6 form-lable">
                                            <label for="name_login">First Name: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="text" formControlName="firstName"
                                                class="form-control textCapital " placeholder="First name" value=""
                                                required
                                                [ngClass]="{ 'is-invalid': submitted && (f.firstName.errors && (f.firstName.dirty || f.firstName.touched))}">
                                            <div *ngIf="((submitted && f.firstName.errors) || (f.firstName.errors && (f.firstName.dirty || f.firstName.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.firstName.errors.required">First Name is required</div>
                                                <div
                                                    *ngIf="!f.firstName.errors.required && signUpForm.get('firstName').hasError('invalidLettersWithSpace')">
                                                    Only
                                                    Alphabets allowed.</div>
                                            </div>
                                        </div>
                                        <div class="Lastname col-6 form-lable">
                                            <label for="name_login">Last Name: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="text" formControlName="lastName"
                                                class="form-control textCapital" placeholder="Last name" value=""
                                                required
                                                [ngClass]="{ 'is-invalid': submitted && (f.lastName.errors && (f.lastName.dirty || f.lastName.touched))}">
                                            <div *ngIf="((submitted && f.lastName.errors) || (f.lastName.errors && (f.lastName.dirty || f.lastName.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                                <div
                                                    *ngIf="!f.lastName.errors.required && signUpForm.get('lastName').hasError('invalidLettersWithSpace')">
                                                    Only
                                                    Alphabets allowed.</div>
                                            </div>
                                        </div>
                                        <div class="Email col-6 form-lable">
                                            <label for="name_login">Email: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <input type="email" formControlName="email" placeholder="Email Address"
                                                class="form-control mb-3"
                                                [ngClass]="{ 'is-invalid': submitted && (f.email.errors && (f.email.dirty || f.email.touched)) }">
                                            <div *ngIf="((submitted && f.email.errors) || (f.email.errors && (f.email.dirty || f.email.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.email.errors.required">Email is required</div>
                                                <div *ngIf="!f.email.errors.required && f.email.errors.email">Enter
                                                    valid email address</div>
                                            </div>
                                        </div>
                                        <div class="Phone col-6 form-lable">
                                            <label for="name_login">Phone Number: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-inputNumber mode="decimal" [useGrouping]="false"
                                                formControlName="mobileNumber" [maxlength]="10"
                                                [ngClass]="{ 'is-invalid': submitted && (f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched))}"
                                                required placeholder="Enter Mobile Number">
                                            </p-inputNumber>
                                            <div *ngIf="((submitted && f.mobileNumber.errors) || (f.mobileNumber.errors && (f.mobileNumber.dirty || f.mobileNumber.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.mobileNumber.errors.required">Mobile number is
                                                    required</div>
                                                <div *ngIf="!f.mobileNumber.errors.required && f.mobileNumber.invalid">
                                                    Please enter a valid 10 digit mobile number</div>
                                            </div>
                                        </div>
                                        <!-- <div class="p-field col-6 form-lable drop-dd">
                                            <label for="country">Country: <span
                                                    class="mandatory-fields">*</span></label>
                                             <p-dropdown inputId="country" [options]="countrylist"
                                                formControlName="country" [filter]="true" (onChange)="getStates($event)"
                                                placeholder="Select Country" optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && f.country.errors }"></p-dropdown>
                                            <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                                                <div *ngIf="f.country.errors.required">Please select country</div>
                                            </div> 
                                            <p-dropdown inputId="country" [options]="countrylist"
                                                formControlName="country" [filter]="true"
                                                (onChange)="getStates(true,$event)" placeholder="Select Country"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && (f.country.invalid && (f.country.dirty || f.country.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.country.errors) || (f.country.errors && (f.country.dirty || f.country.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.country.errors.required">Please Select Country
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="p-field col-6 form-lable drop-dd">
                                            <label for="state">State: <span class="mandatory-fields">*</span></label>
                                            <p-dropdown inputId="state" [options]="stateList" formControlName="state"
                                                [filter]="true" (onChange)="setState($event)" placeholder="Select State"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && f.state.errors }"></p-dropdown>
                                            <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                                                <div *ngIf="f.state.errors.required">Please select state</div>
                                            </div>
                                            <p-dropdown inputId="state" [options]="stateList" formControlName="state"
                                                [filter]="true" (onChange)="setState($event)" placeholder="Select State"
                                                optionLabel="name"
                                                [ngClass]="{ 'is-invalid': submitted && (f.state.invalid && (f.state.dirty || f.state.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.state.errors) || (f.state.errors && (f.state.dirty || f.state.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.state.errors.required">Please Select State
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="city col-6 form-lable mb-3  drop-dd">
                                            <label for="name_login">City: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-dropdown inputId="city" [filter]="true" [options]="cityList"
                                                formControlName="city" (onChange)="onCitySelect($event)"
                                                placeholder="Select City" optionLabel="name"></p-dropdown>
                                            <p-dropdown inputId="city" [options]="cityList" formControlName="city"
                                                [filter]="true" placeholder="Select City" optionLabel="name"
                                                (onChange)="onCitySelect($event)"
                                                [ngClass]="{ 'is-invalid': submitted && (f.city.invalid && (f.city.dirty || f.city.touched))}"></p-dropdown>
                                            <div *ngIf="((submitted && f.city.errors) || (f.city.errors && (f.city.dirty || f.city.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.city.errors.required">Please Select City
                                                </div>
                                            </div>
                                        </div> -->
                                        <!-- <div class="Gender  col-6 form-lable mb-3  drop-dd">
                                            <label for="name_login">Gender:</label>
                                            <div class="clear"></div>
                                            <p-dropdown inputId="gender" [filter]="true" [options]="genders"
                                                formControlName="gender" (onChange)="onGenderSelect($event)"
                                                placeholder="Select Gender" optionLabel="name"></p-dropdown>
                                        </div> -->
                                        <!-- <div class="pwd col-6 form-lable">
                                            <label for="password_login">Password: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-password appendTo="body" [toggleMask]="true" id="password_login"
                                                type="password" formControlName="password" placeholder="********"
                                                class="form-control" value="" autocomplete="on" required
                                                [ngClass]="{ 'is-invalid': submitted && (f.password.invalid && (f.password.dirty || f.password.touched))}"></p-password>
                                            <div *ngIf="((submitted && f.password.errors) || (f.password.errors && (f.password.dirty || f.password.touched)))"
                                                class="invalid-feedback">
                                                <div *ngIf="f.password.errors.required">Password is required</div>
                                                <div *ngIf="!f.password.errors.required && f.password.errors">Password
                                                    should contains at least 1
                                                    digit, 1 lowercase, 1 uppercase, 1 symbol. Length between 6 to 20.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pwd col-6 form-lable">
                                            <label for="password_login">Confirm Password: <span
                                                    class="mandatory-fields">*</span></label>
                                            <div class="clear"></div>
                                            <p-password appendTo="body" [toggleMask]="true" type="password"
                                                formControlName="confirmPassword" placeholder="Confirm Password*"
                                                class="form-control" autocomplete="on" required
                                                [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.invalid && (f.confirmPassword.dirty || f.confirmPassword.touched))}"></p-password>
                                             <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback"> 
                                        <div *ngIf="((submitted && f.confirmPassword.errors) || (f.confirmPassword.errors && (f.confirmPassword.dirty || f.confirmPassword.touched)))"
                                            class="invalid-feedback">
                                            <div *ngIf="f.confirmPassword.errors.required">Confirm Password is
                                                required</div>
                                            <div
                                                *ngIf="!f.confirmPassword.errors.required && f.confirmPassword.errors.mustMatch">
                                                Passwords must match</div>
                                        </div>
                                    </div> -->
                                        <!-- <div class="col-md-6 input-form dates">
                                            <span class="outline-element-container">
                                                <label for="referral"> Date Of Birth:<span
                                                        class="mandatory-fields">*</span></label>
                                                <p-calendar formControlName="dob" [showIcon]="true" inputId="icon"
                                                    placeholder="Birth Date" monthNavigator="true" yearNavigator="true"
                                                    yearRange="{{yearRange}}" class="p-calendar" inputId="calendar"
                                                    [defaultDate]="date" dateFormat="dd/mm/yy" [showIcon]="true"
                                                    [ngClass]="{ 'is-invalid': submitted && (f.dob.errors && (f.dob.dirty || f.dob.touched))}"></p-calendar>

                                                <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                                    
                                                <div *ngIf="((submitted && f.dob.errors) || (f.dob.errors && (f.dob.dirty || f.dob.touched)))"
                                                    class="invalid-feedback">
                                                    <div *ngIf="f.dob.errors.required">Date Of Birth is
                                                        required
                                                    </div>
                                                </div>
                                            </span>
                                        </div> -->


                                        <!-- DOB Validattion Issue Fixed Updated Code -->

                                        <!-- <div class="col-md-6 input-form dates form-lable">
                                            <span class="outline-element-container">
                                                <label for="referral"> Date Of Birth:<span
                                                        class="mandatory-fields">*</span></label>
                                                <p-calendar formControlName="dob" [readonlyInput]="true" inputId="icon"
                                                    placeholder="Birth Date" monthNavigator="true" yearNavigator="true"
                                                    yearRange="{{yearRange}}" class="p-calendar" inputId="calendar"
                                                    [defaultDate]="defaultDate" dateFormat="dd-mm-yy" [showIcon]="true"
                                                    [ngClass]="{ 'is-invalid': submitted && f.dob.invalid}">
                                                </p-calendar>
                                                <div *ngIf="submitted && f.dob.invalid" class="invalid-feedback">
                                                    <div *ngIf="f.dob.errors.required">Date Of Birth is required</div>
                                                </div>
                                            </span>
                                        </div> -->


                                        <div class="referral col-md-6 form-lable">
                                            <label for="referral"> Referral Code <span class="not_m"> (Not
                                                    mandatory)</span> :</label>
                                            <div class="clear"></div>
                                            <input type="text" formControlName="referral"
                                                placeholder="Enter Referral Code" class="form-control">
                                        </div>
                                        <div class="col-md-12 input-form dates roles mb-3 Signup-field">
                                            <label>Signup As:</label>
                                            <div class="lists">
                                                <span *ngFor="let userCategory of userCategories"
                                                    class="field-checkbox">

                                                    <label class="radio-custom" style="width: 100%;">
                                                        <p-radioButton formControlName="{{userCategory.slug}}"
                                                            [value]="userCategory.status"
                                                            (onClick)="onUserCategorySelect(userCategory, $event)">
                                                        </p-radioButton> {{userCategory.name}}
                                                    </label>
                                                </span>
                                                <div *ngIf="showCategoryError">
                                                    <div>
                                                        <span> Please Select User Category</span>
                                                    </div>
                                                </div>
                                                <div *ngIf="showMessage" class="alert-success" role="">
                                                    {{message}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>






                                    <!-- <div class="col-md-6 input-form dates">
                                    <span class="outline-element-container">
                                        <p-calendar formControlName="weddingDate" [showIcon]="true" inputId="icon"
                                            dateFormat="dd/mm/yy" placeholder="Wedding Date"></p-calendar>
                                    </span>
                                </div>
                                <div class="user-note">
                                    <h4>Special discounts given for birthday's and anniversary</h4>
                                </div> -->

                                    <div id="login-submit" class="register-button">
                                        <button class="ragister-btn">Register</button>
                                    </div>
                                </form>
                            </div>
                            <div *ngIf="showOtpForm" class="col-md-12 d-block w-100">
                                <div class="container height-100 d-flex justify-content-center align-items-center">
                                    <div class="position-relative">
                                        <div class=" p-2 text-center otp-screen-div">
                                            <div class="col-md-12 otp-header">
                                                <div class="row">
                                                    <!-- <div class="col-2">
                                                        <div class="back-btn">
                                                            <i class="bi bi-chevron-left"></i>
                                                        </div>
                                                    </div> -->
                                                    <div class="col-12">
                                                        <h2>Mobile Verification</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6>Please enter the one time password <br> to verify your account</h6>
                                            <div> <span>A code has been sent to </span> <small>{{mobileNumber}}</small>
                                            </div>
                                            <div id="otp"
                                                class="inputs d-flex flex-row justify-content-center mt-2 mb-2">
                                                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config">
                                                </ng-otp-input>
                                                <div *ngIf="showOtpErrors && !showOtpErrorsMsg">
                                                    <span style="color: red;">Please enter OTP.</span>
                                                </div>
                                                <div *ngIf="showOtpErrorsMsg">
                                                    <span style="color: red;">{{otpErrorMessage}}</span>
                                                </div>
                                                <!-- <input class="m-2 text-center form-control rounded" type="text"
                                                    id="first" maxlength="1" />
                                                <input class="m-2 text-center form-control rounded" type="text"
                                                    id="second" maxlength="1" />
                                                <input class="m-2 text-center form-control rounded" type="text"
                                                    id="third" maxlength="1" />
                                                <input class="m-2 text-center form-control rounded" type="text"
                                                    id="fourth" maxlength="1" />
                                                <input class="m-2 text-center form-control rounded" type="text"
                                                    id="fifth" maxlength="1" />
                                                <input class="m-2 text-center form-control rounded" type="text"
                                                    id="sixth" maxlength="1" /> -->
                                            </div>
                                            <div>
                                                <span *ngIf="!showResendButton">{{displayTime}}</span>
                                                <span *ngIf="showResendButton">
                                                    <div id="">
                                                        <a (click)="resendOtp()"
                                                            style="text-decoration: underline;cursor: pointer;">Resend</a>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="login-submit">
                                    <input type="submit" (click)="onClickOtpSubmit()" value="Submit">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
<section *ngIf="showForgotPasswordForm" class="login-page-section forgot-password">
    <div class="section-title text-center">
        <p> Forgot Password
        </p>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 ">
                <div class="col-md-12 login-page">
                    <form [formGroup]="forgotPassForm">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="style-form-group forgot-password-div">
                                    <input type="email" formControlName="email" class="form-control form-input"
                                        placeholder="Your Email *"
                                        [ngClass]="{ 'is-invalid': submitted && forgotPassValidation.email.errors }">
                                    <div *ngIf="submitted && forgotPassValidation.email.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forgotPassValidation.email.errors.required">Email is
                                            required</div>
                                        <div *ngIf="forgotPassValidation.email.errors.pattern">Email must be a
                                            valid
                                            email address</div>
                                    </div>
                                    <div *ngIf="successMessage" style="color:green;">{{successMessage.message}}
                                    </div>
                                    <div *ngIf="errorMessage" style="color:red;">{{errorMessage}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="button pt-2 pt-lg-3">
                            <button class="forgot-pass-submit"
                                (click)="onForgotPassSubmit()">Submit</button>&nbsp;&nbsp;
                            <button class="forgot-pass-back" (click)="onForgotPassBack()">Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>